export default __webpack_public_path__ + "static/video-construction-42cd1649e2dfbb7f65db0098d57bcc4e.mp4";